import { FC } from "react";
import { ContractTradeType } from "@/types";
import { Progress as MantineProgress, ProgressProps as MantineProgressProps } from "@mantine/core";
import ContractTradeTypeEnum from "@/constants/enums/ContractTradeTypeEnum";

interface Props extends MantineProgressProps {
  contractTradeType?: ContractTradeType;
}

const Progress: FC<Props> = ({ contractTradeType, ...mantineProps }) => {
  const progressColor = contractTradeType
    ? contractTradeType === ContractTradeTypeEnum.SELL
      ? "var(--color-red-100)"
      : "var(--color-green-100)"
    : null;

  return (
    <MantineProgress
      style={{ position: "relative" }}
      radius={0}
      color={progressColor ? progressColor : undefined}
      {...mantineProps}
    />
  );
};
export default Progress;
